import styled, {css} from 'styled-components';

import Utility from '../../../../../../../../../../util/utilityfunctions';

const lightMode = css`
	--grey: var(--neutrals-900);
`;
const darkMode = css`
	--grey: var(--neutrals-300);
`;

export default styled.div`
	${Utility.isDarkTheme() ? darkMode : lightMode};
	--green: var(--green-500);
	--red: var(--red-600);
	--yellow: var(--brand-500);

	display: flex;
	align-items: center;

	.motif-icon {
		display: flex;
		margin-right: var(--px-5);
		width: var(--px-10);
		height: var(--px-10);
		color: transparent;
		svg {
			cursor: default;
		}
	}

	//PENDING/SENT
	&.sd-3 .motif-icon,
	&.sd-10 .motif-icon {
		color: var(--yellow);
	}
	//ACCEPTED
	&.sd-4 .motif-icon {
		color: var(--green);
	}
	//REJECTED
	&.sd-5 .motif-icon {
		color: var(--red);
	}
	//NOT USING CANVAS
	&.sd-12 .motif-icon {
		color: var(--grey);
	}
`;
